export const copyToClipboard = (textToCopy: string, isMobile: boolean) => {
  if (isMobile) {
    navigator.clipboard.writeText(textToCopy);
  } else {
    const input = document.createElement("textarea");
    input.value = textToCopy;
    document.body.prepend(input);
    input.select();
    input.focus();
    document.execCommand("copy");
    document.body.removeChild(input);
  }
};

const escapeHtml = (value: string) =>
  value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

export const copyLinkToClipboard = async (label: string, url: string) => {
  const html = `<a href="${escapeHtml(url)}">${escapeHtml(label)}</a>`;
  await navigator.clipboard.write([
    new ClipboardItem({
      "text/html": new Blob([html], {type: "text/html"}),
      "text/plain": new Blob([url], {type: "text/plain"}),
    }),
  ]);
};
